import type {
  OverviewFilterObject,
  OverviewColumnType,
} from '@/_types/overview';

// Questionnaire
export const DEFAULT_OVERVIEW_COLUMNS: Array<OverviewColumnType> = [
  'select',
  'client',
  'year',
  'name',
  'status',
  'notes',
  'documents',
  'last_activity',
  'assigned',
  'due_date',
  'actions',
];

export const DEFAULT_OVERVIEW_FILTER: OverviewFilterObject = {
  assigned_advisor_id: -1,
  count: false,
  descending: true,
  entity_type: 'All',
  firm_group_id: -1,
  firm_role_id: -1,
  firm_role_user_id: -1,
  selected_firm_custom_status_filter: [],
  hide_actives: false,
  hide_inactives: false,
  page: 0,
  questionnaire_status: -1,
  questionnaire_status_include_locked: true,
  questionnaire_status_exclude_completed: false,
  questionnaire_type: 'All',
  rows_per_page: 10,
  search_term: '',
  selected_client_tags_filter: [],
  selected_entity_tags_filter: [],
  sort_by: 'last_activity',
  year: 'All',
  hide_inactive_users: false,
  hide_active_users: false,
};

export const OVERVIEW_TABLE_HEADER_MAP: Record<OverviewColumnType, string> = {
  actions: '',
  assigned: 'Assigned',
  client: 'Entity',
  documents: 'Documents',
  due_date: 'Due Date',
  entity: 'Entity',
  entity_type: 'Entity Type',
  external_entity_id: 'External Entity ID',
  external_user_id: 'External User ID',
  firm_custom_status_id: 'Firm-Internal Status',
  firm_group: 'Firm Group',
  firm_role: 'Firm Role',
  first_doc_uploaded_at: 'First Document Uploaded',
  last_activity: 'Last Activity',
  name: 'Name',
  next_reminder_date: 'Next Reminder',
  notes: 'Notes',
  reminder: 'Reminder',
  select: 'Select',
  status: 'Status',
  submitted_at: 'Submitted On',
  year: 'Year',
};
